import { useEffect } from 'react';

function AccessibeFAB() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://acsbapp.com/apps/app/dist/js/app.js';
    script.async = true;
    script.onload = () => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      if (typeof acsbJS !== 'undefined') {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        acsbJS.init();
      } else {
        // console.error('AccessiBe script failed to load.');
      }
    };
    script.onerror = () => {
      // console.error('Failed to load accessiBe script.');
    };

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return null;
}

export default AccessibeFAB;
